module.exports = __webpack_public_path__ + "static/kikiam-2e626ba53fbaba9ad58ef1ef224032ab.jpg";